import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tabset from './tabset-criar-questao';

class CriarQuestoes extends Component {
  render() {
    return (
      <Fragment>
        <Breadcrumb title="Criar questão" parent="Questões" />
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h5>Criar Questões</h5>
            </div>
            <div className="card-body">
              <Tabset />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CriarQuestoes;
